import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

/**
 * Globe icon
 *
 * @file Globe.jsx
 * @author Sam George
 */
const Globe = (props) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path
      fill="currentcolor"
      d="M12,0 C18.627417,0 24,5.372583 24,12 C24,18.627417 18.627417,24 12,24 C5.372583,24 0,18.627417
      0,12 C0,5.372583 5.372583,0 12,0 Z M12,16 C11.0735264,16 10.1810649,16.0493827 9.33577099,16.1383813
      C9.91737584,19.6319332 11.133025,22 12,22 C12.866975,22 14.0826242,19.6319332 14.6635195,16.1371499
      C13.8189688,16.0493846 12.9264911,16 12,16 Z M7.35029554,16.4268622 C5.85567319,16.710882
      4.59333162,17.1094285 3.6719983,17.5376894 C4.91781043,19.40755 6.77658315,20.8341208
      8.9613363,21.5304752 C8.24894044,20.2201862 7.68771071,18.4601965 7.35029554,16.4268622 Z M16.6497826,16.426877
      L16.5828617,16.8060758 C16.2414169,18.6788615 15.7065351,20.3020235 15.0389153,21.5298871
      C17.2234901,20.8338644 19.0821708,19.4074812 20.3292801,17.5374906 C19.4906402,17.1483763
      18.3711348,16.783615 17.0515723,16.5071152 L16.6497826,16.426877 Z M2.75253733,8.18727195
      C2.26755576,9.36227034 2,10.6498897 2,12 C2,13.350409 2.26767414,14.6382993 2.7536673,15.8127568
      C3.92277077,15.2245958 5.408928,14.7498235 7.10300167,14.4350066 C7.0354748,13.6486995 7,12.8342924
      7,12 C7,11.4174849 7.01729409,10.8446641 7.05071723,10.2843335 L7.08947358,9.72826984 L7.10300167,9.56672928
      C5.40845458,9.2507363 3.92194015,8.77578688 2.75253733,8.18727195 Z M21.2473771,8.18736583
      C20.0782004,8.77572619 18.5917951,9.25066064 16.897038,9.56545533 C16.9645391,10.3516195
      17,11.1658709 17,12 C17,12.8342924 16.9645252,13.6486995 16.8973846,14.4339885 C18.5917951,14.7499874
      20.0782004,15.2249219 21.2475509,15.8125143 C21.7324767,14.6375735 22,13.3500285 22,12 C22,10.6499715
      21.7324767,9.36242648 21.2473771,8.18736583 Z M14.9110194,9.85129635 L14.6047409,9.8825328
      C13.766101,9.95987026 12.8944795,10.0006481 12,10.0006481 C10.9958165,10.0006481 10.0204417,9.94925444
      9.08898062,9.85129635 C9.03153154,10.5410813 9,11.259682 9,12 C9,12.7406753 9.03156198,13.4596123
      9.08819966,14.1482126 C10.0204417,14.0513937 10.9958165,14 12,14 C13.0038763,14 13.9789615,14.0513622
      14.9109362,14.1497024 C14.968438,13.4596123 15,12.7406753 15,12 C15,11.4447615 14.9822635,10.901739
      14.9491589,10.3739271 L14.9110194,9.85129635 Z M12,2 C11.1329588,2 9.91719004,4.36842878
      9.3365283,7.86350317 C10.1810649,7.9512654 11.0735264,8.00064809 12,8.00064809
      C12.9264911,8.00064809 13.8189688,7.95126353 14.6643623,7.86241964 C14.08281,4.36842878
      12.8670412,2 12,2 Z M8.96068405,2.47072469 L8.78877137,2.52675349 C6.67839125,3.24189108
      4.8842336,4.64242921 3.67082038,6.46320415 C4.59333162,6.89121963 5.85567319,7.28976605
      7.35117209,7.57348563 C7.66344884,5.6860443 8.16950839,4.03384223 8.81041549,2.75832398
      L8.96068405,2.47072469 Z M15.0389153,2.47011288 L15.2200623,2.81946961 C15.8463416,4.086056
      16.3412042,5.71503101 16.6497826,7.57377104 C18.1444251,7.28974183 19.4067762,6.89118321
      20.3286962,6.46337348 C19.148477,4.69152172 17.4179081,3.31769299 15.3811655,2.58606305
      L15.0389153,2.47011288 Z"
    />
  </SvgIcon>
);

export default Globe;
